$( document ).ready(function() {

    // Setup default data from URL params
    if (window.location.pathname == "/redeem")
    {
        $('#form_name').val( getUrlParameter('name'));
        $('#form_email').val(getUrlParameter('email'));
        $('#form_voucher').val( getUrlParameter('voucher'));
    }
   

    // Register user on click
    $('#register-pluginboutique-button').on('click', function(e)
	{
        e.preventDefault();
        $("#errors").html("");
        $('#register-pluginboutique-button').html('<i class="fa fa-spinner fa-pulse"></i>');
        
		$.ajax({
			url: '/campaign/pluginboutique',
			type: 'post',
			data: $('#pluginboutiqueregisterform').serialize(),
			success: function (response)
			{
                console.log(response); 
				window.location.href = "/userarea?action=purchase";
			},
			error: function (response)
			{
                $("#errors").html('<div class="alert alert-danger" role="alert">' + clearQuotes(response.responseText) + "</div>");
                $('#register-pluginboutique-button').html('Register');
			},
		});
	});

});

// Clears chote charaters from a string
function clearQuotes(stringToClear)
{
    return stringToClear.replace(/^"(.+(?="$))"$/, '$1');
}